window.chatModeState = {
  currentMode: null,
  currentRoom: null,
  liveConnection: null,
  liveSource: null,
  initialized: false,
};

// Only enable chat logic on chat-related pages or when chat UI/data exist
var __isChatPath = /^\/(ai-chat|r)(\/|$)/.test(window.location.pathname);
var __hasChatUI =
  typeof document !== 'undefined' && !!document.querySelector('.chat-log');
var __hasChatData = !!(
  window.fixtures &&
  (window.fixtures.room_name || window.fixtures.currentAI)
);
var __shouldInitChat = __isChatPath || __hasChatUI || __hasChatData;

function cleanupChatConnections() {
  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Cleaning up all chat connections');

  if (typeof EventSourceManager !== 'undefined') {
    EventSourceManager.closeAll();
  }

  if (window.chatModeState.liveSource) {
    window.chatModeState.liveSource.close();
    window.chatModeState.liveSource = null;
  }

  window.chatModeState.liveConnection = null;
  window.chatModeState.currentRoom = null;
}

if (__shouldInitChat) {
  window.addEventListener('beforeunload', cleanupChatConnections);
}

if (__shouldInitChat) {
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (window.NETWRCK_DEBUG)
        console.debug('[CHAT-SWITCHER] Page hidden, cleaning up connections');
      cleanupChatConnections();
    }
  });
}

function detectInitialMode() {
  var path = window.location.pathname;
  var mode = null;
  var config = {};

  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Detecting initial mode from path:', path);
  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Fixtures:', window.fixtures);

  if (
    path.startsWith('/r/') ||
    (window.fixtures && window.fixtures.room_name)
  ) {
    mode = 'chatroom';
    config = {
      room_name: window.fixtures
        ? window.fixtures.room_name
        : path.replace('/r/', '').replace(/-/g, ' '),
      room_ais: window.fixtures ? window.fixtures.room_ais : {},
      messages: window.fixtures ? window.fixtures.messages : [],
    };
  } else if (
    path.startsWith('/ai-chat/') ||
    (window.fixtures && window.fixtures.currentAI)
  ) {
    mode = 'chat';
    config = {
      ai_char: window.fixtures ? window.fixtures.currentAI : null,
    };
  } else {
    var defaultAI =
      (window.fixtures && window.fixtures.currentAI) ||
      window.DefaultAICharacter || {
        name: 'Isekai narrator',
        description:
          'An omniscient narrator for epic isekai roleplay adventures.',
        greeting:
          'Welcome to a world beyond your imagination. What path will you choose?',
        avatar_file_name: '',
      };

    mode = 'chat';
    config = {
      ai_char:
        window.fixtures && window.fixtures.currentAI
          ? window.fixtures.currentAI
          : defaultAI,
    };
  }

  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Detected mode:', mode, 'config:', config);
  return { mode: mode, config: config };
}

function cleanupCurrentMode() {
  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Cleaning up current mode');

  if (window.chatModeState.liveSource) {
    window.chatModeState.liveSource.close();
    window.chatModeState.liveSource = null;
  }

  if (
    window.chatModeState.liveConnection &&
    typeof EventSourceManager !== 'undefined'
  ) {
    EventSourceManager.close(
      window.chatModeState.currentRoom || window.chatModeState.currentMode
    );
    window.chatModeState.liveConnection = null;
  }

  window.chatModeState.currentRoom = null;

  $('.chat-log').empty();

  ['find-room-dialog', 'add-chat-dialog', 'add-room-dialog'].forEach(
    function (dialogId) {
      var dialog = document.getElementById(dialogId);
      if (dialog && dialog.open) {
        dialog.close();
      }
    }
  );
}

window.switchChatMode = function (mode, config, skipHistoryUpdate) {
  if (window.NETWRCK_DEBUG)
    console.debug(
      '[CHAT-SWITCHER] Switching chat mode to:',
      mode,
      'with config:',
      config
    );

  cleanupCurrentMode();

  if (!window.fixtures) {
    window.fixtures = {};
  }

  window.chatModeState.currentMode = mode;

  if (mode === 'chatroom') {
    if (window.fixtures) {
      window.fixtures.room_name = config.room_name || 'New Room';
      window.fixtures.room_ais = config.room_ais || {};
      window.fixtures.currentAI = null;
    }

    $('.chat-one-to-one-icon').hide();
    $('#chat-one-to-one-name').hide();
    $('#chat-one-to-one-name-tags').hide();
    $('#chat-one-to-one-name-tooltip').hide();
    $('#save-button').hide();

    if (!$('.header1-g.white-bg-highlight').length) {
      $('.container').prepend(
        '<h1 class="header1-g white-bg-highlight">' +
          config.room_name +
          ' Chat</h1>'
      );
    } else {
      $('.header1-g.white-bg-highlight').text(config.room_name + ' Chat');
    }

    if (!$('#chatroom-ais-in-room').length) {
      $('.header1-g').after(
        '<div id="chatroom-ais-in-room" class="mdl-grid chatroom-ais-in-room"></div>'
      );
    }

    renderRoomAIs(config.room_ais || {});

    if (!$('#edit-characters-btn').length) {
      $('#chatroom-ais-in-room').after(
        '<a id="edit-characters-btn" class="mdl-list__item-secondary-action" href="#" data-bypass>' +
          '<button class="new-chat-button mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored">' +
          '<i class="material-icons">edit</i>' +
          '</button>' +
          '</a>' +
          '<div id="characters-in-room-tooltip" class="chars-in-room-tooltip playground-tooltip mdl-tooltip mdl-tooltip--large mdl-tooltip--right" for="edit-characters-btn">Edit Characters In Room</div>'
      );
    }

    $('#share-ai-dialog .mdl-dialog__title').text('Share Room');
    $('#share-ai-dialog p:first').text(
      'Share this room (people can see the chats)'
    );

    setupRoomConnection(config.room_name);

    if (config.messages && config.messages.length > 0) {
      loadChatMessages(config.messages, 'chatroom');
    }
  } else {
    if (window.fixtures) {
      window.fixtures.room_name = null;
      window.fixtures.currentAI = config.ai_char || window.fixtures.currentAI;
      window.fixtures.room_ais = {};
    }

    $('.header1-g.white-bg-highlight').remove();
    $('#chatroom-ais-in-room').remove();
    $('#edit-characters-btn').remove();
    $('#characters-in-room-tooltip').remove();

    var currentAI =
      config.ai_char || (window.fixtures ? window.fixtures.currentAI : null);

    var userVoice =
      typeof localStorage !== 'undefined' && localStorage.getItem('preferredVoice');
    if (userVoice && typeof window.setVoice === 'function') {
      window.setVoice(userVoice);
    } else if (currentAI && currentAI.voice && typeof window.setVoice === 'function') {
      window.setVoice(currentAI.voice);
    }

    $('.chat-one-to-one-icon')
      .show()
      .attr(
        'src',
        currentAI && currentAI.avatar_file_name
          ? 'https://netwrckstatic.netwrck.com/static/uploads/' +
              currentAI.avatar_file_name
          : 'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp'
      );
    $('#chat-one-to-one-name')
      .show()
      .text(currentAI ? currentAI.name : 'Netwrck');
    $('#chat-one-to-one-name-tags').show();
    $('#chat-one-to-one-name-tooltip')
      .show()
      .text(
        currentAI && currentAI.description
          ? currentAI.description
          : 'Please Subscribe and support us'
      );
    $('#save-button').show();

    $('#share-ai-dialog .mdl-dialog__title').text('Share Chat');
    $('#share-ai-dialog p:first').text(
      'Anyone with this link can continue from this chat.'
    );

    if (
      currentAI &&
      currentAI.greeting &&
      $('.chat-log .chat-log__item').length === 0
    ) {
      if (typeof appendToChatLog === 'function') {
        appendToChatLog(
          '<div class="chat-log__item"><div class="chat-log__message" contenteditable="" spellcheck="false">' +
            currentAI.greeting +
            '</div></div>'
        );
      } else {
        $('.chat-log').append(
          '<div class="chat-log__item"><div class="chat-log__message" contenteditable="" spellcheck="false">' +
            currentAI.greeting +
            '</div></div>'
        );
      }
    }
  }

  if (!skipHistoryUpdate && window.history && window.history.pushState) {
    var newUrl;
    if (mode === 'chatroom') {
      newUrl =
        '/r/' +
        encodeURIComponent(config.room_name.replace(/ /g, '-').toLowerCase());
    } else if (config.ai_char) {
      newUrl =
        '/ai-chat/' +
        encodeURIComponent(config.ai_char.name.replace(/ /g, '-'));
    }
    var isHome =
      window.location.pathname === '/' ||
      window.location.pathname === '/index.html';
    var isChatMode = mode === 'chat' || mode === 'ai-chat';
    if (newUrl && newUrl !== window.location.pathname) {
      // Do not redirect from homepage to /ai-chat when auto-selecting default AI
      if (!(isChatMode && isHome)) {
        window.history.pushState({ mode: mode, config: config }, '', newUrl);
      }
    }
  }

  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Chat mode switched successfully to:', mode);
};

function renderRoomAIs(roomAIs) {
  var aiCharacters = Object.values(roomAIs);
  var aiHtml = '';

  for (var i = 0; i < aiCharacters.length; i++) {
    var character = aiCharacters[i];
    var characterName = character ? character.name : 'Netwrck';
    var chatLinkOpen =
      character && character.name
        ? '<a class="room-character-chat-link" href="/ai-chat/' +
          encodeURIComponent(
            character.url_name || character.URLName || character.name
          ) +
          '" target="_blank" rel="noopener" data-bypass="true" title="Chat 1:1 with ' +
          characterName +
          ' in a new tab">'
        : '';
    aiHtml +=
      '<div>' +
      chatLinkOpen +
      '<img class="chat-log-avatar-icon" ' +
      'src="' +
      (character && character.avatar_file_name
        ? 'https://netwrckstatic.netwrck.com/static/uploads/' +
          character.avatar_file_name
        : 'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp') +
      '" ' +
      'alt="' +
      characterName +
      '" ' +
      'width="100" height="100">' +
      (chatLinkOpen ? '</a>' : '') +
      '<p id="chat-one-to-one-name-group' +
      (i + 1) +
      '" ' +
      'class="chat-group-member chat-group-name chat-one-to-one-name-group' +
      (i + 1) +
      '">' +
      chatLinkOpen +
      characterName +
      (chatLinkOpen ? '</a>' : '') +
      '</p>' +
      '<div class="chat-one-to-one-name-tooltip playground-tooltip mdl-tooltip mdl-tooltip--large mdl-tooltip--right" ' +
      'for="chat-one-to-one-name-group' +
      (i + 1) +
      '">' +
      (character && character.description
        ? character.description
        : character && character.greeting
          ? character.greeting
          : 'Please Subscribe and support us') +
      '</div>' +
      '<div class="clear"></div><br>' +
      '</div>';
  }
  $('#chatroom-ais-in-room').html(aiHtml);

  if (typeof renderAIsInRoom === 'function') {
    renderAIsInRoom(roomAIs);
  }
}

function setupRoomConnection(roomName) {
  var searchBaseUrl =
    (window.fixtures && window.fixtures.search_base_url) || '';

  if (window.chatModeState.liveConnection) {
    if (window.NETWRCK_DEBUG)
      console.debug(
        '[CHAT-SWITCHER] Closing existing connection before creating new one'
      );
    if (typeof EventSourceManager !== 'undefined') {
      EventSourceManager.close(window.chatModeState.currentRoom);
    } else if (window.chatModeState.liveSource) {
      window.chatModeState.liveSource.close();
      window.chatModeState.liveSource = null;
    }
    window.chatModeState.liveConnection = null;
  }

  if (
    window.chatModeState.currentRoom === roomName &&
    typeof EventSourceManager !== 'undefined' &&
    EventSourceManager.getConnectionState(roomName) === 'connected'
  ) {
    if (window.NETWRCK_DEBUG)
      console.debug('[CHAT-SWITCHER] Already connected to room:', roomName);
    return;
  }

  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Setting up connection to room:', roomName);
  window.chatModeState.currentRoom = roomName;

  if (typeof EventSourceManager !== 'undefined') {
    window.chatModeState.liveConnection = EventSourceManager.create(roomName, {
      baseUrl: searchBaseUrl,
      onMessage: function (e) {
        try {
          var data = JSON.parse(e.data);
          if (data && data.text && data.username) {
            var liveMessage = {
              text: data.text,
              username: data.username,
              avatar_url: data.avatar_url,
              avatar_file_name: data.avatar_file_name,
              attachments: Array.isArray(data.attachments)
                ? data.attachments
                : [],
            };
            renderChatMessage(liveMessage, 'chatroom', 0);
          }
        } catch (err) {
          console.error('[CHAT-SWITCHER] Error parsing message:', err);
        }
      },
      onError: function (err) {
        console.error('[CHAT-SWITCHER] Connection failed:', err);
      },
      onOpen: function () {
        if (window.NETWRCK_DEBUG)
          console.debug(
            '[CHAT-SWITCHER] Successfully connected to room:',
            roomName
          );
      },
    });
  } else {
    if (window.NETWRCK_DEBUG)
      console.debug(
        '[CHAT-SWITCHER] Using fallback EventSource for room:',
        roomName
      );
    if (!roomName || !String(roomName).trim()) {
      console.warn(
        '[CHAT-SWITCHER] Refusing to open live subscribe without a valid room name'
      );
      return;
    }
    window.chatModeState.liveSource = new EventSource(
      searchBaseUrl +
        '/api/live/subscribe?channel=' +
        encodeURIComponent(roomName)
    );
    window.chatModeState.liveSource.onopen = function () {
      if (window.NETWRCK_DEBUG)
        console.debug(
          '[CHAT-SWITCHER] Fallback EventSource connected to room:',
          roomName
        );
      // Reset reconnection state on successful connection
      window.chatModeState.reconnectAttempts = 0;
      window.chatModeState.reconnectDelay = 5000;
    };

    // Initialize reconnection state
    window.chatModeState.reconnectAttempts = 0;
    window.chatModeState.reconnectDelay = 5000; // Start with 5 seconds
    window.chatModeState.maxReconnectDelay = 60000; // Max 1 minute
    window.chatModeState.maxReconnectAttempts = 10;

    window.chatModeState.liveSource.onerror = function (err) {
      console.error(
        '[CHAT-SWITCHER] Fallback EventSource error for room:',
        roomName,
        err
      );

      // Only reconnect if we haven't exceeded max attempts
      if (
        window.chatModeState.reconnectAttempts <
        window.chatModeState.maxReconnectAttempts
      ) {
        window.chatModeState.reconnectAttempts++;
        console.log(
          '[CHAT-SWITCHER] Will reconnect in',
          window.chatModeState.reconnectDelay,
          'ms (attempt',
          window.chatModeState.reconnectAttempts,
          ')'
        );

        setTimeout(function () {
          if (window.chatModeState.liveSource) {
            window.chatModeState.liveSource.close();
          }
          setupLiveConnection(roomName);
        }, window.chatModeState.reconnectDelay);

        // Exponential backoff with jitter
        window.chatModeState.reconnectDelay = Math.min(
          window.chatModeState.reconnectDelay * 2 + Math.random() * 1000,
          window.chatModeState.maxReconnectDelay
        );
      } else {
        console.error(
          '[CHAT-SWITCHER] Max reconnection attempts reached for room:',
          roomName
        );
      }
    };

    window.chatModeState.liveSource.onmessage = function (e) {
      try {
        var data = JSON.parse(e.data);
        if (window.ChatWorkspace?.applyLiveModerationEvent(data)) {
          return;
        }
        if (data.text && data.username) {
          if (typeof appendToChatLog === 'function') {
            appendToChatLog(
              '<img class="chat-log-avatar-icon" src="' +
                (data.avatar_url ||
                  'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp') +
                '" alt="' +
                data.username +
                '" width="100" height="100">' +
                '<p class="chat-group-name">' +
                data.username +
                '</p>' +
                '<div class="chat-log__item">' +
                '<div class="chat-log__message" contenteditable="" spellcheck="false">' +
                data.text +
                '</div>' +
                '</div>',
              undefined,
              data
            );
          }
        }
      } catch (err) {
        console.error('[CHAT-SWITCHER] Error parsing message:', err);
      }
    };
  }
}

function loadChatMessages(messages, mode) {
  if (!messages || messages.length === 0) return;

  if (window.NETWRCK_DEBUG)
    console.debug(
      '[CHAT-SWITCHER] Loading',
      messages.length,
      'messages in',
      mode,
      'mode'
    );

  messages.forEach(function (message, index) {
    renderChatMessage(message, mode, index);
  });
}

function renderChatMessage(message, mode, index) {
  var escapeHtml =
    window.StringUtils && typeof window.StringUtils.escapeHtml === 'function'
      ? window.StringUtils.escapeHtml
      : function (value) {
          if (value === null || value === undefined) return '';
          return String(value).replace(
            /[&<>"']/g,
            function (match) {
              var escapeMap = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;',
              };
              return escapeMap[match] || match;
            }
          );
        };

  function buildAttachmentsMarkup(attachments) {
    if (!Array.isArray(attachments) || attachments.length === 0) {
      return '';
    }
    var markup = '<div class="chat-message-attachments">';
    attachments.forEach(function (att) {
      if (!att || !att.url) {
        return;
      }
      var url = String(att.url || '').trim();
      if (!/^https?:\/\//i.test(url)) {
        return;
      }
      var safeUrl = escapeHtml(url);
      var type = String(att.type || '').toLowerCase();
      var caption = escapeHtml(att.caption || att.alt || '');
      var altText = escapeHtml(att.alt || att.caption || 'Attachment');

      if (type.indexOf('video/') === 0) {
        markup +=
          '<figure class="chat-attachment chat-attachment--video">' +
          '<video controls preload="metadata" src="' +
          safeUrl +
          '" aria-label="' +
          altText +
          '"></video>';
      } else {
        markup +=
          '<figure class="chat-attachment chat-attachment--image">' +
          '<img src="' +
          safeUrl +
          '" alt="' +
          altText +
          '" loading="lazy">';
      }

      if (caption) {
        markup += '<figcaption>' + caption + '</figcaption>';
      }
      markup += '</figure>';
    });
    markup += '</div>';
    return markup;
  }

  var messageText =
    (message && (message.text || message.content || message.Content)) || '';
  var attachmentsHtml = buildAttachmentsMarkup(message && message.attachments);
  var messageHtml = '';

  if (mode === 'chatroom') {
    var avatarSrc = message && message.avatar_url
      ? message.avatar_url
      : message && message.avatar_file_name
        ? 'https://netwrckstatic.netwrck.com/static/uploads/' +
          message.avatar_file_name
        : 'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp';
    messageHtml =
      '<div class="chat-message-block">' +
      '<img class="chat-log-avatar-icon" src="' +
      escapeHtml(avatarSrc) +
      '" alt="' +
      (message.username || 'User') +
      '" width="100" height="100">' +
      '<p class="chat-group-name" tabindex="0">' +
      (message.username || 'User') +
      '</p>' +
      '<div class="chat-log__item"' +
      (message.id ? ' data-message-id="' + escapeHtml(String(message.id)) + '"' : '') +
      ' data-message-author="' +
      escapeHtml(String(message.username || 'User')) +
      '">' +
      (attachmentsHtml || '') +
      '<div class="chat-log__message" contenteditable="" spellcheck="false">' +
      messageText +
      '</div>' +
      '</div>' +
      '</div>';
  } else {
    var isUserMessage =
      message.is_user ||
      (message.username &&
        message.username !==
          (window.fixtures ? window.fixtures.currentAI?.name : ''));
    var messageClass = isUserMessage ? 'chat-log__item--own' : 'chat-log__item';

    messageHtml =
      '<div class="' +
      messageClass +
      '">' +
      (attachmentsHtml || '') +
      '<div class="chat-log__message" contenteditable="" spellcheck="false">' +
      messageText +
      '</div>' +
      '</div>';
  }

  if (typeof appendToChatLog === 'function') {
    appendToChatLog(messageHtml, undefined, message);
  } else {
    $('.chat-log').append(messageHtml);
  }
}

function appendModeAwareMessage(text, username, avatarUrl, isUser) {
  var currentMode = window.chatModeState.currentMode;

  var message = {
    text: text,
    username: username,
    avatar_file_name: avatarUrl,
    is_user: isUser,
  };

  renderChatMessage(message, currentMode, 0);
}

function initializeChatMode() {
  if (window.chatModeState.initialized) {
    return;
  }

  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Initializing chat mode');
  var detection = detectInitialMode();

  if (detection.mode === 'chatroom' && window.fixtures?.private_room_rendered) {
    window.chatModeState.currentMode = detection.mode;
    window.chatModeState.currentRoom = detection.config.room_name;
  } else {
    switchChatMode(detection.mode, detection.config, true);
  }

  window.chatModeState.initialized = true;
}

// Register popstate handler with coordinator if available
(function () {
  var chatSwitcherPopstateHandler = function (event) {
    if (window.NETWRCK_DEBUG)
      console.debug('[CHAT-SWITCHER] popstate event:', event.state);
    if (event.state && event.state.mode) {
      switchChatMode(event.state.mode, event.state.config, true);
    } else {
      var detection = detectInitialMode();
      switchChatMode(detection.mode, detection.config, true);
    }
  };

  if (window.PopStateCoordinator) {
    window.PopStateCoordinator.register(
      chatSwitcherPopstateHandler,
      75, // Higher priority than game.js but lower than NavigationManager
      'ChatModeSwitcher'
    );
  } else {
    window.addEventListener('popstate', chatSwitcherPopstateHandler);
  }
})();

function loadRoomData(roomName, callback) {
  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Loading room data for:', roomName);

  $.ajax({
    url: '/api/room/' + encodeURIComponent(roomName),
    method: 'GET',
    success: function (roomData) {
      if (window.NETWRCK_DEBUG)
        console.debug('[CHAT-SWITCHER] Room data loaded:', roomData);
      callback(null, roomData);
    },
    error: function (xhr, status, error) {
      console.warn('[CHAT-SWITCHER] Failed to load room data:', error);

      callback(null, {
        name: roomName,
        ais: {},
        messages: [],
      });
    },
  });
}

function handleNewRoomCreation(roomName) {
  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Handling new room creation:', roomName);

  transitionToMode('chatroom', {
    room_name: roomName,
    room_ais: {},
    messages: [],
  });
}

function handleAICharacterSelection(aiChar) {
  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Handling AI character selection:', aiChar);

  transitionToMode('chat', {
    ai_char: aiChar,
  });
}

$(document).ready(function () {
  if (__shouldInitChat) {
    initializeChatMode();
  }

  $(document).on('click', '.autocomplete-rooms-list a.mdl-chip', function (e) {
    e.preventDefault();
    var roomName = $(this).find('.mdl-chip__text').text();

    var dialog = document.getElementById('find-room-dialog');
    if (dialog) dialog.close();

    loadRoomData(roomName, function (err, roomData) {
      transitionToMode('chatroom', {
        room_name: roomName,
        room_ais: roomData.ais || {},
        messages: roomData.messages || [],
      });
    });
  });

  $(document).on(
    'click',
    '.autocomplete-users-list a.select-ai-char',
    function (e) {
      e.preventDefault();
      var aiName = $(this).data('name');

      var aiChar = null;
      if (window.dataAccessor && window.dataAccessor.aisByName) {
        aiChar = window.dataAccessor.aisByName[aiName];
      }

      if (!aiChar && window.dataAccessor && window.dataAccessor.currentAIs) {
        var currentAIs = window.dataAccessor.currentAIs || [];
        for (var i = 0; i < currentAIs.length; i++) {
          if (currentAIs[i].name === aiName) {
            aiChar = currentAIs[i];
            break;
          }
        }
      }

      if (aiChar) {
        var dialog = document.getElementById('add-chat-dialog');
        if (dialog) dialog.close();

        handleAICharacterSelection(aiChar);
      }
    }
  );

  if (typeof window.originalRoomCreationSuccess === 'undefined') {
    window.originalRoomCreationSuccess = function (roomName) {
      var urlencodedroomname = encodeURIComponent(roomName.replace(/ /g, '-'));
      window.location.href = '/r/' + urlencodedroomname;
    };
  }

  $(document)
    .off('submit', '#add-room-form')
    .on('submit', '#add-room-form', function (e) {
      e.preventDefault();
      var roomName = $('#roomname').val().trim();

      if (!roomName) {
        alert('Please enter a room name');
        return;
      }

      var dialog = document.getElementById('add-room-dialog');
      if (dialog) dialog.close();

      handleNewRoomCreation(roomName);

      $('#roomname').val('');
    });
});

function smartReRenderCurrentState() {
  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Smart rerendering current state');

  if (
    window.location.href.endsWith('/ai-chatbots') ||
    window.location.href.indexOf('/tools/') !== -1
  ) {
    return;
  }

  var currentMode = window.chatModeState.currentMode;

  if (currentMode === 'chatroom') {
    reRenderChatroomMode();
  } else {
    reRender1v1ChatMode();
  }
}

function reRenderChatroomMode() {
  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Rerendering chatroom mode');

  if (!window.fixtures || !window.fixtures.room_name) {
    console.warn('[CHAT-SWITCHER] No room data available for rerender');
    return;
  }

  $('.header1-g.white-bg-highlight').text(window.fixtures.room_name + ' Chat');

  if (window.fixtures.room_ais) {
    renderRoomAIs(window.fixtures.room_ais);
  }

  $('.header1-g.white-bg-highlight').show();
  $('#chatroom-ais-in-room').show();
  $('#edit-characters-btn').show();

  $('.chat-one-to-one-icon').hide();
  $('#chat-one-to-one-name').hide();
  $('#chat-one-to-one-name-tags').hide();
  $('#chat-one-to-one-name-tooltip').hide();
  $('#save-button').hide();

  $('#share-ai-dialog .mdl-dialog__title').text('Share Room');
  $('#share-ai-dialog p:first').text(
    'Share this room (people can see the chats)'
  );
}

function reRender1v1ChatMode() {
  if (window.NETWRCK_DEBUG)
    console.debug('[CHAT-SWITCHER] Rerendering 1-1 chat mode');

  var currentAI = window.fixtures ? window.fixtures.currentAI : null;

  if (!currentAI) {
    console.warn('[CHAT-SWITCHER] No AI character available for rerender');
    return;
  }

  $('.chat-one-to-one-icon').attr(
    'src',
    currentAI.avatar_file_name
      ? 'https://netwrckstatic.netwrck.com/static/uploads/' +
          currentAI.avatar_file_name
      : 'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp'
  );
  $('.chat-one-to-one-name').text(currentAI.name);
  $('.chat-one-to-one-name-tooltip').text(
    currentAI.description || 'Please Subscribe and support us'
  );

  if (
    window.TemplateUtils &&
    typeof window.TemplateUtils.getTagsTemplate === 'function' &&
    currentAI.tags
  ) {
    $('.chat-one-to-one-name-tags').html(
      window.TemplateUtils.getTagsTemplate(currentAI.tags)
    );
  }

  $('.chat-one-to-one-icon').show();
  $('#chat-one-to-one-name').show();
  $('#chat-one-to-one-name-tags').show();
  $('#chat-one-to-one-name-tooltip').show();
  $('#save-button').show();

  $('.header1-g.white-bg-highlight').hide();
  $('#chatroom-ais-in-room').hide();
  $('#edit-characters-btn').hide();

  $('#share-ai-dialog .mdl-dialog__title').text('Share Chat');
  $('#share-ai-dialog p:first').text(
    'Anyone with this link can continue from this chat.'
  );

  if (
    typeof questionsgame !== 'undefined' &&
    typeof questionsgame.Game === 'function'
  ) {
    reInitializeGameState(currentAI);
  }
}

function reInitializeGameState(currentAI) {
  if (window.NETWRCK_DEBUG)
    console.debug(
      '[CHAT-SWITCHER] Reinitializing game state for AI:',
      currentAI.name
    );

  var userName =
    window.userData && (window.userData?.username || window.userData?.name)
      ? window.userData?.username || window.userData?.name
      : 'Noo';

  var input = currentAI.greeting ? currentAI.greeting : currentAI.description;
  if (!input) {
    input = 'Hello there!';
  }

  if (
    window.fixtures &&
    window.fixtures.save_game_json &&
    window.fixtures.save_game_json.backstory
  ) {
    input = window.fixtures.save_game_json.backstory;
  }

  input = input.replace('{{name}}', userName);
  input = input.replace('{{user}}', userName);
  input = input.replace('[user]', userName);

  if (userName !== 'Noo') {
    input = input.replace(
      'Login and set your name or everyone calls you... Noo',
      'Hi ' + userName
    );
  }

  input = currentAI.name + ': ' + input;

  if (!window.questionsgame) {
    console.warn(
      '[CHAT-SWITCHER] window.questionsgame not initialized, attempting to initialize'
    );
    if (typeof setupGameInit === 'function') {
      setupGameInit();
    } else if (typeof window.setupGameInit === 'function') {
      window.setupGameInit();
    }
  }
  if (window.questionsgame && window.questionsgame.Game) {
    window.questionsgame.game = new window.questionsgame.Game(input);
  } else {
    console.error(
      '[CHAT-SWITCHER] Unable to initialize game: questionsgame.Game not available'
    );
    return;
  }

  if (window.questionsgame && window.questionsgame.game) {
    window.questionsgame.game.lastGeneratedText = (
      currentAI.greeting || ''
    ).replace('{{user}}', userName);
    window.questionsgame.game.cannedResponseUsed = false;
    window.questionsgame.game.textGeneratorFallbackUsed = false;
  }

  // Note: Greeting is already handled by switchChatMode function, no need to duplicate it here
}

function transitionToMode(newMode, config) {
  if (window.NETWRCK_DEBUG)
    console.debug(
      '[CHAT-SWITCHER] Transitioning to mode:',
      newMode,
      'from:',
      window.chatModeState.currentMode
    );

  var currentMode = window.chatModeState.currentMode;
  var savedState = null;

  if (
    currentMode === 'chat' &&
    typeof rebuildGameState === 'function' &&
    window.questionsgame &&
    window.questionsgame.game
  ) {
    try {
      savedState = rebuildGameState(window.questionsgame.game);
      if (window.NETWRCK_DEBUG)
        console.debug(
          '[CHAT-SWITCHER] Saved current 1-1 chat state:',
          savedState
        );
    } catch (e) {
      console.warn('[CHAT-SWITCHER] Could not save current game state:', e);
    }
  }

  if (
    currentMode === 'chatroom' &&
    window.fixtures &&
    window.fixtures.room_name
  ) {
    var roomMessages = extractCurrentChatMessages('chatroom');
    if (window.NETWRCK_DEBUG)
      console.debug(
        '[CHAT-SWITCHER] Saved current room messages:',
        roomMessages.length
      );

    window.chatModeState.lastRoomState = {
      room_name: window.fixtures.room_name,
      room_ais: window.fixtures.room_ais,
      messages: roomMessages,
    };
  }

  cleanupCurrentMode();

  switchChatMode(newMode, config);
}

function extractCurrentChatMessages(mode) {
  var messages = [];

  if (mode === 'chatroom') {
    $('.chat-message-block').each(function () {
      var $block = $(this);
      var username = $block.find('.chat-group-name').text();
      var text = $block.find('.chat-log__message').text();
      var avatarSrc = $block.find('.chat-log-avatar-icon').attr('src');
      var avatar_file_name = null;

      if (avatarSrc && avatarSrc.includes('/uploads/')) {
        avatar_file_name = avatarSrc
          .replace('https://netwrckstatic.netwrck.com/static/uploads/', '')
          .replace('/uploads/', '');
      }

      if (text && username) {
        messages.push({
          username: username,
          text: text,
          avatar_file_name: avatar_file_name,
        });
      }
    });
  } else {
    $('.chat-log__item').each(function () {
      var $item = $(this);
      var text = $item.find('.chat-log__message').text();
      var isUser = $item.hasClass('chat-log__item--own');

      if (text) {
        messages.push({
          text: text,
          is_user: isUser,
          username: isUser
            ? window.userData
              ? window.userData?.username || window.userData?.name || 'User'
              : 'User'
            : window.fixtures
              ? window.fixtures.currentAI && window.fixtures.currentAI.name
              : 'AI',
        });
      }
    });
  }

  return messages;
}

if (typeof window.originalReRenderCurrentGame === 'undefined') {
  window.originalReRenderCurrentGame =
    window.ReRenderCurrentGame || function () {};
}

window.ReRenderCurrentGame = function () {
  if (window.NETWRCK_DEBUG)
    console.debug(
      '[CHAT-SWITCHER] ReRenderCurrentGame called - using smart rerender'
    );

  if (!window.chatModeState || !window.chatModeState.initialized) {
    if (typeof window.originalReRenderCurrentGame === 'function') {
      return window.originalReRenderCurrentGame.apply(this, arguments);
    }
    return;
  }

  smartReRenderCurrentState();
};

window.handleNewRoomCreation = handleNewRoomCreation;
window.handleAICharacterSelection = handleAICharacterSelection;
window.loadRoomData = loadRoomData;
window.initializeChatMode = initializeChatMode;
window.smartReRenderCurrentState = smartReRenderCurrentState;
window.transitionToMode = transitionToMode;
window.appendModeAwareMessage = appendModeAwareMessage;
window.renderChatMessage = renderChatMessage;
window.extractCurrentChatMessages = extractCurrentChatMessages;
